import useWorkflow from "./hooks/useWorkflow";

import WorkflowHeader from "./components/WorkflowHeader";
import WorkflowSidebar from "./components/WorkflowSidebar";
import WorkflowCanvas from "./components/WorkflowCanvas";
import WorkflowProperties from "./components/WorkflowProperties";
import { AlertCircle, RefreshCw } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import "src/stage/stage.css";
import "src/stage/crm-stage.css";
import "./pipelines-stage.css";

export default function WorkflowBuilder() {
    const { pipeline: pipelineId } = useParams();
    const navigate = useNavigate();
    const workflow = useWorkflow(pipelineId);

    return (
        <div className="crm-builder ws-overlay flex h-screen min-h-0 flex-col overflow-hidden bg-[#f4f9fe]">

            <WorkflowHeader workflow={workflow} />

            {workflow.error && !workflow.workflow ? (
                <div className="flex flex-1 items-center justify-center p-6">
                    <div className="w-full max-w-lg rounded-3xl border border-red-100 bg-white p-8 text-center shadow-[0_18px_50px_rgba(31,78,121,0.10)]">
                        <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-red-50 text-red-600"><AlertCircle className="h-6 w-6" /></span>
                        <h2 className="mt-4 text-xl font-bold text-[#102b5c]">Pipeline unavailable</h2>
                        <p className="mt-2 text-sm leading-6 text-[#6c7f9f]">{workflow.error}</p>
                        <div className="mt-6 flex justify-center gap-3">
                            <button type="button" onClick={() => navigate("/admin/pipelines")} className="rounded-xl border border-[#d5e4f2] bg-white px-4 py-2.5 text-sm font-bold text-[#536b91] transition hover:bg-[#f5f9fd]">Back to pipelines</button>
                            <button type="button" onClick={workflow.refreshWorkflow} className="inline-flex items-center gap-2 rounded-xl bg-[#147db5] px-4 py-2.5 text-sm font-bold text-white transition hover:bg-[#0f6f9f]"><RefreshCw className="h-4 w-4" /> Try again</button>
                        </div>
                    </div>
                </div>
            ) : (
            <div className="relative grid min-h-0 flex-1 grid-cols-[15rem_minmax(0,1fr)] overflow-hidden xl:grid-cols-[17.5rem_minmax(28rem,1fr)_20rem]">

                <aside className="min-h-0 border-r border-[#dce8f3] bg-white">
                    <WorkflowSidebar workflow={workflow} />
                </aside>

                <main className="min-h-0 min-w-0 overflow-hidden bg-[#f7fbff]">
                    <WorkflowCanvas workflow={workflow} />
                </main>

                <aside className="absolute inset-y-0 right-0 z-20 min-h-0 w-72 border-l border-[#dce8f3] bg-white shadow-[-12px_0_30px_rgba(31,78,121,0.08)] xl:static xl:w-auto xl:shadow-none">
                    <WorkflowProperties workflow={workflow} />
                </aside>

            </div>
            )}

        </div>
    );
}
